const ScopeType = Object.freeze({
  ALL: 'ALL',
  ACTIVITIES: 'ACTIVITIES',
  ALIGNMENT: 'ALIGNMENT',
  GROUPS: 'GROUPS',
  PROCESSES: 'PROCESSES',
  PROPERTIES: 'PROPERTIES',
  SPANS_LAYERS: 'SPANS_LAYERS',
  ROLES: 'ROLES',
  PRIORITISATION: 'PRIORITISATION',
  SKILLS: 'SKILLS',
  SUMMARY: 'SUMMARY',
  TAGS: 'TAGS',
  CUSTOM_CHARTS: 'CUSTOM_CHARTS',
});

export default ScopeType;
